"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const common_styled_components_1 = require("../common-styled-components");
const SurplusCalculator_1 = require("./SurplusCalculator");
const MainCardContent = styled_components_1.default.div `
  width: 100%;
  display: block;
`;
const MainPanel = styled_components_1.default.main `
  width: 100%;
  min-height: 520px;
  background: ${theme_1.theme.colors.grey(5)};
`;
const HeaderBar = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme_1.theme.spacing(2)};
  min-height: 110px;
  padding: ${theme_1.theme.spacing(3)} ${theme_1.theme.spacing(4)};
  background: linear-gradient(
    90deg,
    ${theme_1.theme.colors.lightBlue} 0%,
    ${theme_1.theme.colors.blue} 100%
  );
  color: ${theme_1.theme.colors.white};
  box-sizing: border-box;
`;
const HeaderTitle = styled_components_1.default.h1 `
  ${theme_1.theme.fontTitle};
  ${theme_1.theme.fontSize(2)};
  margin: 0;
  color: ${theme_1.theme.colors.white};
`;
const ContentArea = styled_components_1.default.div `
  padding: ${theme_1.theme.spacing(4)};

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    padding: ${theme_1.theme.spacing(3)};
  }
`;
const PageHeader = styled_components_1.default.header `
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${theme_1.theme.spacing(4)};
  flex-wrap: wrap;
  width: 100%;
  border-bottom: 2px solid ${theme_1.theme.colors.darkBlue};
  padding-bottom: ${theme_1.theme.spacing(2)};
`;
const Headline = (0, styled_components_1.default)(common_styled_components_1.ToolTitle) `
  margin: 0;
  line-height: 1.3;

  span {
    color: ${theme_1.theme.colors.lightBlue};
  }
`;
const BiofuelSwitchCalculator = () => {
    return ((0, jsx_runtime_1.jsxs)(ContentArea, { children: [(0, jsx_runtime_1.jsx)(PageHeader, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Headline, { children: "What your biofuel switch is worth in the pool" }) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.LeadText, { children: "Set the fuel switch you are considering and see the compliance surplus it generates, the FuelEU penalty that surplus avoids, the EU ETS cost it saves, and what the biofuel premium costs." }), (0, jsx_runtime_1.jsx)(SurplusCalculator_1.SurplusCalculator, {})] }));
};
exports.default = BiofuelSwitchCalculator;
